import * as React from "react";
const SvgFileCode = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.773 5c-.011 0-.19.165-.396.367A5.49 5.49 0 0 0 1 5.754c0 .011 1.365 1.352 3.035 2.98l3.037 2.961-3.037 2.961A308.877 308.877 0 0 0 1 17.636c0 .028.746.755.773.755.012 0 1.567-1.507 3.456-3.348l3.433-3.348L5.23 8.348A387.987 387.987 0 0 0 1.773 5Zm12.58 8.266v1.074H23v-1.074h-4.324z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgFileCode;
